import {
  whiteColor,
  grayColor,
  defaultFont,
  dangerColor,
  successColor,
  infoColor
} from "../../material-kit-pro-react.jsx";

const datePickerStyle = {
    formControl: {
        margin: "0px",
        paddingTop: "0px",
        position: "relative",
        "& .MuiIconButton-root": {
            padding: "0px",
        },
        "& .MuiIconButton-root:hover": {
            backgroundColor: "transparent",
        },
        "& .MuiInputBase-root.Mui-disabled": {
            backgroundColor: grayColor[19]
        },
        "& svg,& .fab,& .far,& .fal,& .fas,& .material-icons": {
            color: grayColor[13]
        },
        "& .MuiFormLabel-root.Mui-focused": {
            color: infoColor[0]
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: infoColor[0]
        },
        "& .MuiInput-underline, & .MuiInput-underline:before": {
            borderBottomColor: grayColor[11] + " !important",
            borderBottomWidth: "1px !important"
        },
        "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
            borderBottomColor: infoColor[0]
        },
        "& .MuiFormLabel-root": {
            ...defaultFont,
            color: grayColor[12] + " !important",
            fontWeight: "400",
            fontSize: "14px",
            lineHeight: "1.42857",
            letterSpacing: "unset",
        },
        "& .MuiFormLabel-root.Mui-error": {
            color: dangerColor[0]+ " !important",
        },
        "& .MuiFormLabel-root.MuiFormLabel-filled:not(.Mui-error)":{
            color: successColor[0]+ " !important",
        },
        "& .MuiInput-underline.Mui-error:after": {
            borderBottomWidth: "1px !important",
            borderBottomColor: grayColor[11],
        },
        "& input": {
            color: grayColor[13],
            height: "unset",
            "&,&::placeholder": {
                fontSize: "14px",
                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                fontWeight: "400",
                lineHeight: "1.42857",
                opacity: "1"
            },
            "&::placeholder": {
                color: grayColor[12]
            }
        },
    },
    feedback: {
        position: "absolute",
        bottom: "4px",
        right: "25px",
        zIndex: "2",
        display: "block",
        width: "24px",
        height: "24px",
        textAlign: "center",
        pointerEvents: "none"
    },
    labelRootError: {
        color: dangerColor[0] + " !important"
    },
    labelRootSuccess: {
        color: successColor[0] + " !important"
    },
    modalRoot: {
        zIndex: "1500 !important",
        "& .MuiPickersToolbar-toolbar": {
            backgroundColor: infoColor[0]
        },
        "& .MuiPickerDTTabs-tabs": {
            backgroundColor: infoColor[0],
            "& .MuiTabs-indicator": {
                backgroundColor: infoColor[4],
            }
        },
        "& .MuiPickersDay-current": {
            color: whiteColor,
        },
        "& .MuiPickersDay-daySelected": {
            backgroundColor: infoColor[0],
        },
        "& .MuiPickersClock-pin": {
            backgroundColor: infoColor[0],
        },
        "& .MuiPickersClockPointer-noPoint": {
            backgroundColor: infoColor[0],
        },
        "& .MuiPickersClockPointer-thumb": {
            borderColor: infoColor[0],
        },
        "& .MuiPickersClockPointer-pointer": {
            backgroundColor: infoColor[0],
        },
        "& .MuiButton-text": {
            color: infoColor[0],
        }
    },
    buttonDisabled: {
        display: "none"
    }
};

export default datePickerStyle;
